/* Polyfill service v3.111.0
 * Disable minification (remove `.min` from URL path) for more info */
function addURLToGlobal() {
    if (globalThis) {
        if (globalThis.hasAddURLToGlobal) {
            return;
        }
        globalThis.hasAddURLToGlobal = true;
    }
(function(self, undefined) {
  if (!("defineProperty"in Object && function() {
      try {
          var e = {}
          return Object.defineProperty(e, "test", {
              value: 42
          }),
          !0
      } catch (t) {
          return !1
      }
  }())) {
      !function(e) {
          var t = Object.prototype.hasOwnProperty.call(Object.prototype, "__defineGetter__")
            , r = "A property cannot both have accessors and be writable or have a value";
          Object.defineProperty = function n(o, i, f) {
              if (e && (o === window || o === document || o === Element.prototype || o instanceof Element))
                  return e(o, i, f);
              if (null === o || !(o instanceof Object || "object" == typeof o))
                  throw new TypeError("Object.defineProperty called on non-object");
              if (!(f instanceof Object))
                  throw new TypeError("Property description must be an object");
              var c = String(i)
                , a = "value"in f || "writable"in f
                , p = "get"in f && typeof f.get
                , s = "set"in f && typeof f.set;
              if (p) {
                  if (p === undefined)
                      return o;
                  if ("function" !== p)
                      throw new TypeError("Getter must be a function");
                  if (!t)
                      throw new TypeError("Getters & setters cannot be defined on this javascript engine");
                  if (a)
                      throw new TypeError(r);
                  Object.__defineGetter__.call(o, c, f.get)
              } else
                  o[c] = f.value;
              if (s) {
                  if (s === undefined)
                      return o;
                  if ("function" !== s)
                      throw new TypeError("Setter must be a function");
                  if (!t)
                      throw new TypeError("Getters & setters cannot be defined on this javascript engine");
                  if (a)
                      throw new TypeError(r);
                  Object.__defineSetter__.call(o, c, f.set)
              }
              return "value"in f && (o[c] = f.value),
              o
          }
      }(Object.defineProperty);
  }
  function ArrayCreate(r) {
      if (1 / r == -Infinity && (r = 0),
      r > Math.pow(2, 32) - 1)
          throw new RangeError("Invalid array length");
      var n = [];
      return n.length = r,
      n
  }
  function Call(t, l) {
      var n = arguments.length > 2 ? arguments[2] : [];
      if (!1 === IsCallable(t))
          throw new TypeError(Object.prototype.toString.call(t) + "is not a function.");
      return t.apply(l, n)
  }
  function CreateDataProperty(e, r, t) {
      var a = {
          value: t,
          writable: !0,
          enumerable: !0,
          configurable: !0
      };
      try {
          return Object.defineProperty(e, r, a),
          !0
      } catch (n) {
          return !1
      }
  }
  function CreateDataPropertyOrThrow(t, r, o) {
      var e = CreateDataProperty(t, r, o);
      if (!e)
          throw new TypeError("Cannot assign value `" + Object.prototype.toString.call(o) + "` to property `" + Object.prototype.toString.call(r) + "` on object `" + Object.prototype.toString.call(t) + "`");
      return e
  }
  function CreateMethodProperty(e, r, t) {
      var a = {
          value: t,
          writable: !0,
          enumerable: !1,
          configurable: !0
      };
      Object.defineProperty(e, r, a)
  }
  if (!("freeze"in Object)) {
      CreateMethodProperty(Object, "freeze", function e(r) {
          return r
      });
  }
  if (!("getPrototypeOf"in Object)) {
      CreateMethodProperty(Object, "getPrototypeOf", function t(o) {
          if (o !== Object(o))
              throw new TypeError("Object.getPrototypeOf called on non-object");
          var e = o.__proto__;
          return e || null === e ? e : "function" == typeof o.constructor && o instanceof o.constructor ? o.constructor.prototype : o instanceof Object ? Object.prototype : null
      });
  }
  if (!("keys"in Object && function() {
      return 2 === Object.keys(arguments).length
  }(1, 2) && function() {
      try {
          return Object.keys(""),
          !0
      } catch (t) {
          return !1
      }
  }())) {
      CreateMethodProperty(Object, "keys", function() {
          "use strict";
          function t() {
              var t;
              try {
                  t = Object.create({})
              } catch (r) {
                  return !0
              }
              return o.call(t, "__proto__")
          }
          function r(t) {
              var r = n.call(t)
                , e = "[object Arguments]" === r;
              return e || (e = "[object Array]" !== r && null !== t && "object" == typeof t && "number" == typeof t.length && t.length >= 0 && "[object Function]" === n.call(t.callee)),
              e
          }
          var e = Object.prototype.hasOwnProperty
            , n = Object.prototype.toString
            , o = Object.prototype.propertyIsEnumerable
            , c = !o.call({
              toString: null
          }, "toString")
            , l = o.call(function() {}, "prototype")
            , i = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"]
            , u = function(t) {
              var r = t.constructor;
              return r && r.prototype === t
          }
            , a = {
              $console: !0,
              $external: !0,
              $frame: !0,
              $frameElement: !0,
              $frames: !0,
              $innerHeight: !0,
              $innerWidth: !0,
              $outerHeight: !0,
              $outerWidth: !0,
              $pageXOffset: !0,
              $pageYOffset: !0,
              $parent: !0,
              $scrollLeft: !0,
              $scrollTop: !0,
              $scrollX: !0,
              $scrollY: !0,
              $self: !0,
              $webkitIndexedDB: !0,
              $webkitStorageInfo: !0,
              $window: !0
          }
            , f = function() {
              if ("undefined" == typeof window)
                  return !1;
              for (var t in window)
                  try {
                      if (!a["$" + t] && e.call(window, t) && null !== window[t] && "object" == typeof window[t])
                          try {
                              u(window[t])
                          } catch (r) {
                              return !0
                          }
                  } catch (r) {
                      return !0
                  }
              return !1
          }()
            , p = function(t) {
              if ("undefined" == typeof window || !f)
                  return u(t);
              try {
                  return u(t)
              } catch (r) {
                  return !1
              }
          };
          return function s(o) {
              var u = "[object Function]" === n.call(o)
                , a = r(o)
                , f = "[object String]" === n.call(o)
                , s = [];
              if (o === undefined || null === o)
                  throw new TypeError("Cannot convert undefined or null to object");
              var y = l && u;
              if (f && o.length > 0 && !e.call(o, 0))
                  for (var h = 0; h < o.length; ++h)
                      s.push(String(h));
              if (a && o.length > 0)
                  for (var g = 0; g < o.length; ++g)
                      s.push(String(g));
              else
                  for (var w in o)
                      t() && "__proto__" === w || y && "prototype" === w || !e.call(o, w) || s.push(String(w));
              if (c)
                  for (var d = p(o), $ = 0; $ < i.length; ++$)
                      d && "constructor" === i[$] || !e.call(o, i[$]) || s.push(i[$]);
              return s
          }
      }());
  }
  function Get(n, t) {
      return n[t]
  }
  function HasOwnProperty(r, t) {
      return Object.prototype.hasOwnProperty.call(r, t)
  }
  function HasProperty(n, r) {
      return r in n
  }
  function IsArray(r) {
      return "[object Array]" === Object.prototype.toString.call(r)
  }
  if (!("isArray"in Array)) {
      CreateMethodProperty(Array, "isArray", function r(e) {
          return IsArray(e)
      });
  }
  function IsCallable(n) {
      return "function" == typeof n
  }
  if (!("bind"in Function.prototype)) {
      CreateMethodProperty(Function.prototype, "bind", function t(n) {
          var r = Array
            , o = Object
            , e = r.prototype
            , l = function g() {}
            , p = e.slice
            , a = e.concat
            , i = e.push
            , c = Math.max
            , u = this;
          if (!IsCallable(u))
              throw new TypeError("Function.prototype.bind called on incompatible " + u);
          for (var y, h = p.call(arguments, 1), s = function() {
              if (this instanceof y) {
                  var t = u.apply(this, a.call(h, p.call(arguments)));
                  return o(t) === t ? t : this
              }
              return u.apply(n, a.call(h, p.call(arguments)))
          }, f = c(0, u.length - h.length), b = [], d = 0; d < f; d++)
              i.call(b, "$" + d);
          return y = Function("binder", "return function (" + b.join(",") + "){ return binder.apply(this, arguments); }")(s),
          u.prototype && (l.prototype = u.prototype,
          y.prototype = new l,
          l.prototype = null),
          y
      });
  }
  function SameValueNonNumber(e, n) {
      return e === n
  }
  function ToBoolean(o) {
      return Boolean(o)
  }
  function ToObject(e) {
      if (null === e || e === undefined)
          throw TypeError();
      return Object(e)
  }
  function GetV(t, e) {
      return ToObject(t)[e]
  }
  function GetMethod(e, n) {
      var r = GetV(e, n);
      if (null === r || r === undefined)
          return undefined;
      if (!1 === IsCallable(r))
          throw new TypeError("Method not callable: " + n);
      return r
  }
  function Type(e) {
      switch (typeof e) {
      case "undefined":
          return "undefined";
      case "boolean":
          return "boolean";
      case "number":
          return "number";
      case "string":
          return "string";
      case "symbol":
          return "symbol";
      default:
          return null === e ? "null" : "Symbol"in self && (e instanceof self.Symbol || e.constructor === self.Symbol) ? "symbol" : "object"
      }
  }
  if (!("isExtensible"in Object)) {
      !function(e) {
          CreateMethodProperty(Object, "isExtensible", function t(n) {
              return "object" === Type(n) && (!e || e(n))
          })
      }(Object.isExtensible);
  }
  function CreateIterResultObject(e, r) {
      if ("boolean" !== Type(r))
          throw new Error;
      var t = {};
      return CreateDataProperty(t, "value", e),
      CreateDataProperty(t, "done", r),
      t
  }
  function GetPrototypeFromConstructor(t, o) {
      var r = Get(t, "prototype");
      return "object" !== Type(r) && (r = o),
      r
  }
  function IsConstructor(t) {
      return "object" === Type(t) && ("function" == typeof t && !!t.prototype)
  }
  function IteratorClose(r, t) {
      if ("object" !== Type(r["[[Iterator]]"]))
          throw new Error(Object.prototype.toString.call(r["[[Iterator]]"]) + "is not an Object.");
      var e = r["[[Iterator]]"]
        , o = GetMethod(e, "return");
      if (o === undefined)
          return t;
      try {
          var n = Call(o, e)
      } catch (c) {
          var a = c
      }
      if (t)
          return t;
      if (a)
          throw a;
      if ("object" !== Type(n))
          throw new TypeError("Iterator's return method returned a non-object.");
      return t
  }
  function IteratorComplete(t) {
      if ("object" !== Type(t))
          throw new Error(Object.prototype.toString.call(t) + "is not an Object.");
      return ToBoolean(Get(t, "done"))
  }
  function IteratorNext(t) {
      if (arguments.length < 2)
          var e = Call(t["[[NextMethod]]"], t["[[Iterator]]"]);
      else
          e = Call(t["[[NextMethod]]"], t["[[Iterator]]"], [arguments[1]]);
      if ("object" !== Type(e))
          throw new TypeError("bad iterator");
      return e
  }
  function IteratorStep(t) {
      var r = IteratorNext(t);
      return !0 !== IteratorComplete(r) && r
  }
  function IteratorValue(t) {
      if ("object" !== Type(t))
          throw new Error(Object.prototype.toString.call(t) + "is not an Object.");
      return Get(t, "value")
  }
  function OrdinaryToPrimitive(r, t) {
      if ("string" === t)
          var e = ["toString", "valueOf"];
      else
          e = ["valueOf", "toString"];
      for (var i = 0; i < e.length; ++i) {
          var n = e[i]
            , a = Get(r, n);
          if (IsCallable(a)) {
              var o = Call(a, r);
              if ("object" !== Type(o))
                  return o
          }
      }
      throw new TypeError("Cannot convert to primitive.")
  }
  function SameValueZero(n, e) {
      return Type(n) === Type(e) && ("number" === Type(n) ? !(!isNaN(n) || !isNaN(e)) || (1 / n === Infinity && 1 / e == -Infinity || (1 / n == -Infinity && 1 / e === Infinity || n === e)) : SameValueNonNumber(n, e))
  }
  function ToInteger(n) {
      if ("symbol" === Type(n))
          throw new TypeError("Cannot convert a Symbol value to a number");
      var t = Number(n);
      return isNaN(t) ? 0 : 1 / t === Infinity || 1 / t == -Infinity || t === Infinity || t === -Infinity ? t : (t < 0 ? -1 : 1) * Math.floor(Math.abs(t))
  }
  function ToLength(n) {
      var t = ToInteger(n);
      return t <= 0 ? 0 : Math.min(t, Math.pow(2, 53) - 1)
  }
  function ToPrimitive(e) {
      var t = arguments.length > 1 ? arguments[1] : undefined;
      if ("object" === Type(e)) {
          if (arguments.length < 2)
              var i = "default";
          else
              t === String ? i = "string" : t === Number && (i = "number");
          var r = "function" == typeof self.Symbol && "symbol" == typeof self.Symbol.toPrimitive ? GetMethod(e, self.Symbol.toPrimitive) : undefined;
          if (r !== undefined) {
              var n = Call(r, e, [i]);
              if ("object" !== Type(n))
                  return n;
              throw new TypeError("Cannot convert exotic object to primitive.")
          }
          return "default" === i && (i = "number"),
          OrdinaryToPrimitive(e, i)
      }
      return e
  }
  function ToString(t) {
      switch (Type(t)) {
      case "symbol":
          throw new TypeError("Cannot convert a Symbol value to a string");
      case "object":
          return ToString(ToPrimitive(t, String));
      default:
          return String(t)
      }
  }
  if (!("forEach"in Array.prototype)) {
      CreateMethodProperty(Array.prototype, "forEach", function r(t) {
          var e = ToObject(this)
            , n = e instanceof String ? e.split("") : e
            , o = ToLength(Get(e, "length"));
          if (!1 === IsCallable(t))
              throw new TypeError(t + " is not a function");
          for (var a = arguments.length > 1 ? arguments[1] : undefined, i = 0; i < o; ) {
              var f = ToString(i);
              if (HasProperty(n, f)) {
                  var l = Get(n, f);
                  Call(t, a, [l, i, e])
              }
              i += 1
          }
          return undefined
      });
  }
  if (!("includes"in Array.prototype)) {
      CreateMethodProperty(Array.prototype, "includes", function e(r) {
          "use strict";
          var t = ToObject(this)
            , o = ToLength(Get(t, "length"));
          if (0 === o)
              return !1;
          var n = ToInteger(arguments[1]);
          if (n >= 0)
              var a = n;
          else
              (a = o + n) < 0 && (a = 0);
          for (; a < o; ) {
              var i = Get(t, ToString(a));
              if (SameValueZero(r, i))
                  return !0;
              a += 1
          }
          return !1
      });
  }
  if (!("indexOf"in Array.prototype)) {
      CreateMethodProperty(Array.prototype, "indexOf", function r(t) {
          var e = ToObject(this)
            , n = ToLength(Get(e, "length"));
          if (0 === n)
              return -1;
          var i = ToInteger(arguments[1]);
          if (i >= n)
              return -1;
          if (i >= 0)
              var o = 1 / i == -Infinity ? 0 : i;
          else
              (o = n + i) < 0 && (o = 0);
          for (; o < n; ) {
              if (HasProperty(e, ToString(o))) {
                  if (t === Get(e, ToString(o)))
                      return o
              }
              o += 1
          }
          return -1
      });
  }
  if (!("getOwnPropertyNames"in Object && function() {
      try {
          return Object.getOwnPropertyNames(1),
          !0
      } catch (t) {
          return !1
      }
  }())) {
      !function() {
          var t = {}.toString
            , e = "".split
            , r = [].concat
            , o = Object.prototype.hasOwnProperty
            , c = Object.getOwnPropertyNames || Object.keys
            , n = "object" == typeof self ? c(self) : [];
          CreateMethodProperty(Object, "getOwnPropertyNames", function l(a) {
              var p = ToObject(a);
              if ("[object Window]" === t.call(p))
                  try {
                      return c(p)
                  } catch (j) {
                      return r.call([], n)
                  }
              p = "[object String]" == t.call(p) ? e.call(p, "") : Object(p);
              for (var i = c(p), s = ["length", "prototype"], O = 0; O < s.length; O++) {
                  var b = s[O];
                  o.call(p, b) && !i.includes(b) && i.push(b)
              }
              if (i.includes("__proto__")) {
                  var f = i.indexOf("__proto__");
                  i.splice(f, 1)
              }
              return i
          })
      }();
  }
  function ToPropertyKey(r) {
      var i = ToPrimitive(r, String);
      return "symbol" === Type(i) ? i : ToString(i)
  }
  if (!("getOwnPropertyDescriptor"in Object && "function" == typeof Object.getOwnPropertyDescriptor && function() {
      try {
          return "3" === Object.getOwnPropertyDescriptor("13.7", 1).value
      } catch (t) {
          return !1
      }
  }())) {
      !function() {
          var e = Object.getOwnPropertyDescriptor
            , t = function() {
              try {
                  return 1 === Object.defineProperty(document.createElement("div"), "one", {
                      get: function() {
                          return 1
                      }
                  }).one
              } catch (e) {
                  return !1
              }
          }
            , r = {}.toString
            , n = "".split;
          CreateMethodProperty(Object, "getOwnPropertyDescriptor", function c(o, i) {
              var a = ToObject(o);
              a = ("string" === Type(a) || a instanceof String) && "[object String]" == r.call(o) ? n.call(o, "") : Object(o);
              var u = ToPropertyKey(i);
              if (t)
                  try {
                      return e(a, u)
                  } catch (l) {}
              if (HasOwnProperty(a, u))
                  return {
                      enumerable: !0,
                      configurable: !0,
                      writable: !0,
                      value: a[u]
                  }
          })
      }();
  }
  if (!("defineProperties"in Object)) {
      CreateMethodProperty(Object, "defineProperties", function e(r, t) {
          if ("object" !== Type(r))
              throw new TypeError("Object.defineProperties called on non-object");
          for (var o = ToObject(t), n = Object.keys(o), c = [], i = 0; i < n.length; i++) {
              var b = n[i]
                , f = Object.getOwnPropertyDescriptor(o, b);
              if (f !== undefined && f.enumerable) {
                  var p = Get(o, b)
                    , a = p;
                  c.push([b, a])
              }
          }
          for (var j = 0; j < c.length; j++) {
              var d = c[j][0];
              a = c[j][1],
              Object.defineProperty(r, d, a)
          }
          return r
      });
  }
  if (!("create"in Object)) {
      !function() {
          function e() {}
          if ({
              __proto__: null
          }instanceof Object)
              t = function() {
                  var e = document.createElement("iframe");
                  e.style.display = "none";
                  var o = document.body || document.documentElement;
                  o.appendChild(e),
                  e.src = "javascript:";
                  var n = e.contentWindow.Object.prototype;
                  o.removeChild(e),
                  e = null,
                  delete n.constructor,
                  delete n.hasOwnProperty,
                  delete n.propertyIsEnumerable,
                  delete n.isPrototypeOf,
                  delete n.toLocaleString,
                  delete n.toString,
                  delete n.valueOf;
                  var r = function l() {};
                  return r.prototype = n,
                  t = function() {
                      return new r
                  }
                  ,
                  new r
              }
              ;
          else
              var t = function() {
                  return {
                      __proto__: null
                  }
              };
          CreateMethodProperty(Object, "create", function o(n, r) {
              if ("object" !== Type(n) && "null" !== Type(n))
                  throw new TypeError("Object prototype may only be an Object or null");
              if ("null" === Type(n))
                  var l = t();
              else
                  e.prototype = n,
                  l = new e,
                  l.__proto__ = n,
                  l.constructor.prototype = n,
                  l.__proto__ = n;
              return 1 in arguments ? Object.defineProperties(l, r) : l
          })
      }();
  }
  function OrdinaryCreateFromConstructor(r, e) {
      var t = arguments[2] || {}
        , o = GetPrototypeFromConstructor(r, e)
        , a = Object.create(o);
      for (var n in t)
          Object.prototype.hasOwnProperty.call(t, n) && Object.defineProperty(a, n, {
              configurable: !0,
              enumerable: !1,
              writable: !0,
              value: t[n]
          });
      return a
  }
  function Construct(r) {
      var t = arguments.length > 2 ? arguments[2] : r
        , o = arguments.length > 1 ? arguments[1] : [];
      if (!IsConstructor(r))
          throw new TypeError("F must be a constructor.");
      if (!IsConstructor(t))
          throw new TypeError("newTarget must be a constructor.");
      if (t === r)
          return new (Function.prototype.bind.apply(r, [null].concat(o)));
      var n = OrdinaryCreateFromConstructor(t, Object.prototype);
      return Call(r, n, o)
  }
  function ArraySpeciesCreate(e, r) {
      if (0 === r && 1 / r == -Infinity && (r = 0),
      !1 === IsArray(e))
          return ArrayCreate(r);
      var n = Get(e, "constructor");
      if ("object" === Type(n) && null === (n = "Symbol"in self && "species"in self.Symbol ? Get(n, self.Symbol.species) : undefined) && (n = undefined),
      n === undefined)
          return ArrayCreate(r);
      if (!IsConstructor(n))
          throw new TypeError("C must be a constructor");
      return Construct(n, [r])
  }
  if (!("filter"in Array.prototype)) {
      CreateMethodProperty(Array.prototype, "filter", function r(e) {
          var t = ToObject(this)
            , o = ToLength(Get(t, "length"));
          if (!1 === IsCallable(e))
              throw new TypeError(e + " is not a function");
          for (var a = arguments.length > 1 ? arguments[1] : undefined, n = ArraySpeciesCreate(t, 0), i = 0, l = 0; i < o; ) {
              var f = ToString(i);
              if (HasProperty(t, f)) {
                  var h = Get(t, f);
                  ToBoolean(Call(e, a, [h, i, t])) && (CreateDataPropertyOrThrow(n, ToString(l), h),
                  l += 1)
              }
              i += 1
          }
          return n
      });
  }
  if (!("map"in Array.prototype)) {
      CreateMethodProperty(Array.prototype, "map", function r(e) {
          var t = ToObject(this)
            , a = ToLength(Get(t, "length"));
          if (!1 === IsCallable(e))
              throw new TypeError(e + " is not a function");
          for (var o = arguments.length > 1 ? arguments[1] : undefined, n = ArraySpeciesCreate(t, a), i = 0; i < a; ) {
              var p = ToString(i);
              if (HasProperty(t, p)) {
                  var h = Get(t, p)
                    , l = Call(e, o, [h, i, t]);
                  CreateDataPropertyOrThrow(n, p, l)
              }
              i += 1
          }
          return n
      });
  }
  if (!("Symbol"in self && 0 === self.Symbol.length)) {
      !function(e, r, n) {
          "use strict";
          function t(e) {
              if ("symbol" === Type(e))
                  return e;
              throw TypeError(e + " is not a symbol")
          }
          var u, o = function() {
              try {
                  var r = {};
                  return e.defineProperty(r, "t", {
                      configurable: !0,
                      enumerable: !1,
                      get: function() {
                          return !0
                      },
                      set: undefined
                  }),
                  !!r.t
              } catch (n) {
                  return !1
              }
          }(), i = 0, a = "" + Math.random(), c = "__symbol:", l = c.length, f = "__symbol@@" + a, s = {}, v = "defineProperty", y = "defineProperties", b = "getOwnPropertyNames", p = "getOwnPropertyDescriptor", h = "propertyIsEnumerable", m = e.prototype, d = m.hasOwnProperty, g = m[h], w = m.toString, S = Array.prototype.concat, P = e.getOwnPropertyNames ? e.getOwnPropertyNames(self) : [], O = e[b], j = function $(e) {
              if ("[object Window]" === w.call(e))
                  try {
                      return O(e)
                  } catch (r) {
                      return S.call([], P)
                  }
              return O(e)
          }, E = e[p], N = e.create, T = e.keys, _ = e.freeze || e, k = e[v], F = e[y], I = E(e, b), x = function(e, r, n) {
              if (!d.call(e, f))
                  try {
                      k(e, f, {
                          enumerable: !1,
                          configurable: !1,
                          writable: !1,
                          value: {}
                      })
                  } catch (t) {
                      e[f] = {}
                  }
              e[f]["@@" + r] = n
          }, z = function(e, r) {
              var n = N(e);
              return j(r).forEach(function(e) {
                  q.call(r, e) && L(n, e, r[e])
              }),
              n
          }, A = function(e) {
              var r = N(e);
              return r.enumerable = !1,
              r
          }, D = function ee() {}, M = function(e) {
              return e != f && !d.call(H, e)
          }, W = function(e) {
              return e != f && d.call(H, e)
          }, q = function re(e) {
              var r = "" + e;
              return W(r) ? d.call(this, r) && this[f] && this[f]["@@" + r] : g.call(this, e)
          }, B = function(r) {
              var n = {
                  enumerable: !1,
                  configurable: !0,
                  get: D,
                  set: function(e) {
                      u(this, r, {
                          enumerable: !1,
                          configurable: !0,
                          writable: !0,
                          value: e
                      }),
                      x(this, r, !0)
                  }
              };
              try {
                  k(m, r, n)
              } catch (o) {
                  m[r] = n.value
              }
              H[r] = k(e(r), "constructor", J);
              var t = E(G.prototype, "description");
              return t && k(H[r], "description", t),
              _(H[r])
          }, C = function(e) {
              var r = t(e);
              if (Y) {
                  var n = V(r);
                  if ("" !== n)
                      return n.slice(1, -1)
              }
              if (s[r] !== undefined)
                  return s[r];
              var u = r.toString()
                , o = u.lastIndexOf("0.");
              return u = u.slice(10, o),
              "" === u ? undefined : u
          }, G = function ne() {
              var r = arguments[0];
              if (this instanceof ne)
                  throw new TypeError("Symbol is not a constructor");
              var n = c.concat(r || "", a, ++i);
              r === undefined || null !== r && !isNaN(r) && "" !== String(r) || (s[n] = String(r));
              var t = B(n);
              return o || e.defineProperty(t, "description", {
                  configurable: !0,
                  enumerable: !1,
                  value: C(t)
              }),
              t
          }, H = N(null), J = {
              value: G
          }, K = function(e) {
              return H[e]
          }, L = function te(e, r, n) {
              var t = "" + r;
              return W(t) ? (u(e, t, n.enumerable ? A(n) : n),
              x(e, t, !!n.enumerable)) : k(e, r, n),
              e
          }, Q = function(e) {
              return function(r) {
                  return d.call(e, f) && d.call(e[f], "@@" + r)
              }
          }, R = function ue(e) {
              return j(e).filter(e === m ? Q(e) : W).map(K)
          };
          I.value = L,
          k(e, v, I),
          I.value = R,
          k(e, "getOwnPropertySymbols", I),
          I.value = function oe(e) {
              return j(e).filter(M)
          }
          ,
          k(e, b, I),
          I.value = function ie(e, r) {
              var n = R(r);
              return n.length ? T(r).concat(n).forEach(function(n) {
                  q.call(r, n) && L(e, n, r[n])
              }) : F(e, r),
              e
          }
          ,
          k(e, y, I),
          I.value = q,
          k(m, h, I),
          I.value = G,
          k(n, "Symbol", I),
          I.value = function(e) {
              var r = c.concat(c, e, a);
              return r in m ? H[r] : B(r)
          }
          ,
          k(G, "for", I),
          I.value = function(e) {
              if (M(e))
                  throw new TypeError(e + " is not a symbol");
              return d.call(H, e) ? e.slice(2 * l, -a.length) : void 0
          }
          ,
          k(G, "keyFor", I),
          I.value = function ae(e, r) {
              var n = E(e, r);
              return n && W(r) && (n.enumerable = q.call(e, r)),
              n
          }
          ,
          k(e, p, I),
          I.value = function ce(e, r) {
              return 1 === arguments.length || void 0 === r ? N(e) : z(e, r)
          }
          ,
          k(e, "create", I);
          var U = null === function() {
              return this
          }
          .call(null);
          if (I.value = U ? function() {
              var e = w.call(this);
              return "[object String]" === e && W(this) ? "[object Symbol]" : e
          }
          : function() {
              if (this === window)
                  return "[object Null]";
              var e = w.call(this);
              return "[object String]" === e && W(this) ? "[object Symbol]" : e
          }
          ,
          k(m, "toString", I),
          u = function(e, r, n) {
              var t = E(m, r);
              delete m[r],
              k(e, r, n),
              e !== m && k(m, r, t)
          }
          ,
          function() {
              try {
                  var r = {};
                  return e.defineProperty(r, "t", {
                      configurable: !0,
                      enumerable: !1,
                      get: function() {
                          return !0
                      },
                      set: undefined
                  }),
                  !!r.t
              } catch (n) {
                  return !1
              }
          }()) {
              var V;
              try {
                  V = Function("s", "var v = s.valueOf(); return { [v]() {} }[v].name;")
              } catch (Z) {}
              var X = function() {}
                , Y = V && "inferred" === X.name ? V : null;
              e.defineProperty(n.Symbol.prototype, "description", {
                  configurable: !0,
                  enumerable: !1,
                  get: function() {
                      return C(this)
                  }
              })
          }
      }(Object, 0, self);
  }
  if (!("Symbol"in self && "iterator"in self.Symbol)) {
      Object.defineProperty(self.Symbol, "iterator", {
          value: self.Symbol("iterator")
      });
  }
  function GetIterator(t) {
      var e = arguments.length > 1 ? arguments[1] : GetMethod(t, Symbol.iterator)
        , r = Call(e, t);
      if ("object" !== Type(r))
          throw new TypeError("bad iterator");
      var o = GetV(r, "next")
        , a = Object.create(null);
      return a["[[Iterator]]"] = r,
      a["[[NextMethod]]"] = o,
      a["[[Done]]"] = !1,
      a
  }
  if (!("Symbol"in self && "species"in self.Symbol)) {
      Object.defineProperty(Symbol, "species", {
          value: Symbol("species")
      });
  }
  if (!("Map"in self && function(t) {
      try {
          var n = new t.Map([[1, 1], [2, 2]])
          return 0 === t.Map.length && 2 === n.size && "Symbol"in t && "iterator"in t.Symbol && "function" == typeof n[t.Symbol.iterator]
      } catch (e) {
          return !1
      }
  }(self))) {
      !function(e) {
          function t(e, t) {
              if ("object" !== Type(e))
                  throw new TypeError("createMapIterator called on incompatible receiver " + Object.prototype.toString.call(e));
              if (!0 !== e._es6Map)
                  throw new TypeError("createMapIterator called on incompatible receiver " + Object.prototype.toString.call(e));
              var r = Object.create(u);
              return Object.defineProperty(r, "[[Map]]", {
                  configurable: !0,
                  enumerable: !1,
                  writable: !0,
                  value: e
              }),
              Object.defineProperty(r, "[[MapNextIndex]]", {
                  configurable: !0,
                  enumerable: !1,
                  writable: !0,
                  value: 0
              }),
              Object.defineProperty(r, "[[MapIterationKind]]", {
                  configurable: !0,
                  enumerable: !1,
                  writable: !0,
                  value: t
              }),
              r
          }
          var r = function() {
              try {
                  var e = {};
                  return Object.defineProperty(e, "t", {
                      configurable: !0,
                      enumerable: !1,
                      get: function() {
                          return !0
                      },
                      set: undefined
                  }),
                  !!e.t
              } catch (t) {
                  return !1
              }
          }()
            , o = 0
            , a = Symbol("meta_" + (1e8 * Math.random() + "").replace(".", ""))
            , n = function(e) {
              if ("object" == typeof e ? null !== e : "function" == typeof e) {
                  if (!Object.isExtensible(e))
                      return !1;
                  if (!Object.prototype.hasOwnProperty.call(e, a)) {
                      var t = typeof e + "-" + ++o;
                      Object.defineProperty(e, a, {
                          configurable: !1,
                          enumerable: !1,
                          writable: !1,
                          value: t
                      })
                  }
                  return e[a]
              }
              return "" + e
          }
            , i = function(e, t) {
              var r = n(t);
              if (!1 === r)
                  return p(e, t);
              var o = e._table[r];
              return o !== undefined && o
          }
            , p = function(e, t) {
              for (var r = 0; r < e._keys.length; r++) {
                  var o = e._keys[r];
                  if (o !== c && SameValueZero(o, t))
                      return r
              }
              return !1
          }
            , l = function(e, t, r) {
              var o = n(t);
              return !1 !== o && (!1 === r ? delete e._table[o] : e._table[o] = r,
              !0)
          }
            , c = Symbol("undef")
            , y = function f() {
              if (!(this instanceof f))
                  throw new TypeError('Constructor Map requires "new"');
              var e = OrdinaryCreateFromConstructor(this, f.prototype, {
                  _table: {},
                  _keys: [],
                  _values: [],
                  _size: 0,
                  _es6Map: !0
              });
              r || Object.defineProperty(e, "size", {
                  configurable: !0,
                  enumerable: !1,
                  writable: !0,
                  value: 0
              });
              var t = arguments.length > 0 ? arguments[0] : undefined;
              if (null === t || t === undefined)
                  return e;
              var o = e.set;
              if (!IsCallable(o))
                  throw new TypeError("Map.prototype.set is not a function");
              try {
                  for (var a = GetIterator(t); ; ) {
                      var n = IteratorStep(a);
                      if (!1 === n)
                          return e;
                      var i = IteratorValue(n);
                      if ("object" !== Type(i))
                          try {
                              throw new TypeError("Iterator value " + i + " is not an entry object")
                          } catch (u) {
                              return IteratorClose(a, u)
                          }
                      try {
                          var p = i[0]
                            , l = i[1];
                          o.call(e, p, l)
                      } catch (s) {
                          return IteratorClose(a, s)
                      }
                  }
              } catch (s) {
                  if (Array.isArray(t) || "[object Arguments]" === Object.prototype.toString.call(t) || t.callee) {
                      var c, y = t.length;
                      for (c = 0; c < y; c++)
                          o.call(e, t[c][0], t[c][1])
                  }
              }
              return e
          };
          Object.defineProperty(y, "prototype", {
              configurable: !1,
              enumerable: !1,
              writable: !1,
              value: {}
          }),
          r ? Object.defineProperty(y, Symbol.species, {
              configurable: !0,
              enumerable: !1,
              get: function() {
                  return this
              },
              set: undefined
          }) : CreateMethodProperty(y, Symbol.species, y),
          CreateMethodProperty(y.prototype, "clear", function b() {
              var e = this;
              if ("object" !== Type(e))
                  throw new TypeError("Method Map.prototype.clear called on incompatible receiver " + Object.prototype.toString.call(e));
              if (!0 !== e._es6Map)
                  throw new TypeError("Method Map.prototype.clear called on incompatible receiver " + Object.prototype.toString.call(e));
              for (var t = e._keys, o = 0; o < t.length; o++)
                  e._keys[o] = c,
                  e._values[o] = c;
              return this._size = 0,
              r || (this.size = this._size),
              this._table = {},
              undefined
          }),
          CreateMethodProperty(y.prototype, "constructor", y),
          CreateMethodProperty(y.prototype, "delete", function(e) {
              var t = this;
              if ("object" !== Type(t))
                  throw new TypeError("Method Map.prototype.clear called on incompatible receiver " + Object.prototype.toString.call(t));
              if (!0 !== t._es6Map)
                  throw new TypeError("Method Map.prototype.clear called on incompatible receiver " + Object.prototype.toString.call(t));
              var o = i(t, e);
              if (!1 !== o) {
                  var a = t._keys[o];
                  if (a !== c && SameValueZero(a, e))
                      return this._keys[o] = c,
                      this._values[o] = c,
                      this._size = --this._size,
                      r || (this.size = this._size),
                      l(this, e, !1),
                      !0
              }
              return !1
          }),
          CreateMethodProperty(y.prototype, "entries", function h() {
              return t(this, "key+value")
          }),
          CreateMethodProperty(y.prototype, "forEach", function(e) {
              var t = this;
              if ("object" !== Type(t))
                  throw new TypeError("Method Map.prototype.forEach called on incompatible receiver " + Object.prototype.toString.call(t));
              if (!0 !== t._es6Map)
                  throw new TypeError("Method Map.prototype.forEach called on incompatible receiver " + Object.prototype.toString.call(t));
              if (!IsCallable(e))
                  throw new TypeError(Object.prototype.toString.call(e) + " is not a function.");
              if (arguments[1])
                  var r = arguments[1];
              for (var o = t._keys, a = 0; a < o.length; a++)
                  t._keys[a] !== c && t._values[a] !== c && e.call(r, t._values[a], t._keys[a], t);
              return undefined
          }),
          CreateMethodProperty(y.prototype, "get", function d(e) {
              var t = this;
              if ("object" !== Type(t))
                  throw new TypeError("Method Map.prototype.get called on incompatible receiver " + Object.prototype.toString.call(t));
              if (!0 !== t._es6Map)
                  throw new TypeError("Method Map.prototype.get called on incompatible receiver " + Object.prototype.toString.call(t));
              var r = i(t, e);
              if (!1 !== r) {
                  var o = t._keys[r];
                  if (o !== c && SameValueZero(o, e))
                      return t._values[r]
              }
              return undefined
          }),
          CreateMethodProperty(y.prototype, "has", function v(e) {
              var t = this;
              if ("object" != typeof t)
                  throw new TypeError("Method Map.prototype.has called on incompatible receiver " + Object.prototype.toString.call(t));
              if (!0 !== t._es6Map)
                  throw new TypeError("Method Map.prototype.has called on incompatible receiver " + Object.prototype.toString.call(t));
              var r = i(t, e);
              if (!1 !== r) {
                  var o = t._keys[r];
                  if (o !== c && SameValueZero(o, e))
                      return !0
              }
              return !1
          }),
          CreateMethodProperty(y.prototype, "keys", function M() {
              return t(this, "key")
          }),
          CreateMethodProperty(y.prototype, "set", function w(e, t) {
              var o = this;
              if ("object" !== Type(o))
                  throw new TypeError("Method Map.prototype.set called on incompatible receiver " + Object.prototype.toString.call(o));
              if (!0 !== o._es6Map)
                  throw new TypeError("Method Map.prototype.set called on incompatible receiver " + Object.prototype.toString.call(o));
              var a = i(o, e);
              if (!1 !== a)
                  o._values[a] = t;
              else {
                  -0 === e && (e = 0);
                  var n = {
                      "[[Key]]": e,
                      "[[Value]]": t
                  };
                  o._keys.push(n["[[Key]]"]),
                  o._values.push(n["[[Value]]"]),
                  l(o, e, o._keys.length - 1),
                  ++o._size,
                  r || (o.size = o._size)
              }
              return o
          }),
          r && Object.defineProperty(y.prototype, "size", {
              configurable: !0,
              enumerable: !1,
              get: function() {
                  var e = this;
                  if ("object" !== Type(e))
                      throw new TypeError("Method Map.prototype.size called on incompatible receiver " + Object.prototype.toString.call(e));
                  if (!0 !== e._es6Map)
                      throw new TypeError("Method Map.prototype.size called on incompatible receiver " + Object.prototype.toString.call(e));
                  return this._size
              },
              set: undefined
          }),
          CreateMethodProperty(y.prototype, "values", function j() {
              return t(this, "value")
          }),
          CreateMethodProperty(y.prototype, Symbol.iterator, y.prototype.entries),
          "name"in y || Object.defineProperty(y, "name", {
              configurable: !0,
              enumerable: !1,
              writable: !1,
              value: "Map"
          });
          var u = {};
          Object.defineProperty(u, "isMapIterator", {
              configurable: !1,
              enumerable: !1,
              writable: !1,
              value: !0
          }),
          CreateMethodProperty(u, "next", function _() {
              var e = this;
              if ("object" !== Type(e))
                  throw new TypeError("Method %MapIteratorPrototype%.next called on incompatible receiver " + Object.prototype.toString.call(e));
              if (!e.isMapIterator)
                  throw new TypeError("Method %MapIteratorPrototype%.next called on incompatible receiver " + Object.prototype.toString.call(e));
              var t = e["[[Map]]"]
                , r = e["[[MapNextIndex]]"]
                , o = e["[[MapIterationKind]]"];
              if (t === undefined)
                  return CreateIterResultObject(undefined, !0);
              if (!t._es6Map)
                  throw new Error(Object.prototype.toString.call(t) + " has a [[MapData]] internal slot.");
              for (var a = t._keys, n = a.length; r < n; ) {
                  var i = Object.create(null);
                  if (i["[[Key]]"] = t._keys[r],
                  i["[[Value]]"] = t._values[r],
                  r += 1,
                  e["[[MapNextIndex]]"] = r,
                  i["[[Key]]"] !== c) {
                      if ("key" === o)
                          var p = i["[[Key]]"];
                      else if ("value" === o)
                          p = i["[[Value]]"];
                      else {
                          if ("key+value" !== o)
                              throw new Error;
                          p = [i["[[Key]]"], i["[[Value]]"]]
                      }
                      return CreateIterResultObject(p, !1)
                  }
              }
              return e["[[Map]]"] = undefined,
              CreateIterResultObject(undefined, !0)
          }),
          CreateMethodProperty(u, Symbol.iterator, function g() {
              return this
          });
          try {
              CreateMethodProperty(e, "Map", y)
          } catch (s) {
              e.Map = y
          }
      }(self);
  }
  if (!("Set"in self && function() {
      try {
          var e = new self.Set([1, 2])
          return 0 === self.Set.length && 2 === e.size && "Symbol"in self && "iterator"in self.Symbol && "function" == typeof e[self.Symbol.iterator]
      } catch (t) {
          return !1
      }
  }())) {
      !function(e) {
          function t(e, t) {
              if ("object" != typeof e)
                  throw new TypeError("createSetIterator called on incompatible receiver " + Object.prototype.toString.call(e));
              if (!0 !== e._es6Set)
                  throw new TypeError("createSetIterator called on incompatible receiver " + Object.prototype.toString.call(e));
              var r = Object.create(i);
              return Object.defineProperty(r, "[[IteratedSet]]", {
                  configurable: !0,
                  enumerable: !1,
                  writable: !0,
                  value: e
              }),
              Object.defineProperty(r, "[[SetNextIndex]]", {
                  configurable: !0,
                  enumerable: !1,
                  writable: !0,
                  value: 0
              }),
              Object.defineProperty(r, "[[SetIterationKind]]", {
                  configurable: !0,
                  enumerable: !1,
                  writable: !0,
                  value: t
              }),
              r
          }
          var r = function() {
              try {
                  var e = {};
                  return Object.defineProperty(e, "t", {
                      configurable: !0,
                      enumerable: !1,
                      get: function() {
                          return !0
                      },
                      set: undefined
                  }),
                  !!e.t
              } catch (t) {
                  return !1
              }
          }()
            , o = Symbol("undef")
            , n = function c() {
              if (!(this instanceof c))
                  throw new TypeError('Constructor Set requires "new"');
              var e = OrdinaryCreateFromConstructor(this, c.prototype, {
                  _values: [],
                  _size: 0,
                  _es6Set: !0
              });
              r || Object.defineProperty(e, "size", {
                  configurable: !0,
                  enumerable: !1,
                  writable: !0,
                  value: 0
              });
              var t = arguments.length > 0 ? arguments[0] : undefined;
              if (null === t || t === undefined)
                  return e;
              var o = e.add;
              if (!IsCallable(o))
                  throw new TypeError("Set.prototype.add is not a function");
              try {
                  for (var n = GetIterator(t); ; ) {
                      var a = IteratorStep(n);
                      if (!1 === a)
                          return e;
                      var i = IteratorValue(a);
                      try {
                          o.call(e, i)
                      } catch (y) {
                          return IteratorClose(n, y)
                      }
                  }
              } catch (y) {
                  if (!Array.isArray(t) && "[object Arguments]" !== Object.prototype.toString.call(t) && !t.callee)
                      throw y;
                  var l, p = t.length;
                  for (l = 0; l < p; l++)
                      o.call(e, t[l])
              }
              return e
          };
          Object.defineProperty(n, "prototype", {
              configurable: !1,
              enumerable: !1,
              writable: !1,
              value: {}
          }),
          r ? Object.defineProperty(n, Symbol.species, {
              configurable: !0,
              enumerable: !1,
              get: function() {
                  return this
              },
              set: undefined
          }) : CreateMethodProperty(n, Symbol.species, n),
          CreateMethodProperty(n.prototype, "add", function p(e) {
              var t = this;
              if ("object" != typeof t)
                  throw new TypeError("Method Set.prototype.add called on incompatible receiver " + Object.prototype.toString.call(t));
              if (!0 !== t._es6Set)
                  throw new TypeError("Method Set.prototype.add called on incompatible receiver " + Object.prototype.toString.call(t));
              for (var n = t._values, a = 0; a < n.length; a++) {
                  var i = n[a];
                  if (i !== o && SameValueZero(i, e))
                      return t
              }
              return 0 === e && 1 / e == -Infinity && (e = 0),
              t._values.push(e),
              this._size = ++this._size,
              r || (this.size = this._size),
              t
          }),
          CreateMethodProperty(n.prototype, "clear", function y() {
              var e = this;
              if ("object" != typeof e)
                  throw new TypeError("Method Set.prototype.clear called on incompatible receiver " + Object.prototype.toString.call(e));
              if (!0 !== e._es6Set)
                  throw new TypeError("Method Set.prototype.clear called on incompatible receiver " + Object.prototype.toString.call(e));
              for (var t = e._values, n = 0; n < t.length; n++)
                  t[n] = o;
              return this._size = 0,
              r || (this.size = this._size),
              undefined
          }),
          CreateMethodProperty(n.prototype, "constructor", n),
          CreateMethodProperty(n.prototype, "delete", function(e) {
              var t = this;
              if ("object" != typeof t)
                  throw new TypeError("Method Set.prototype.delete called on incompatible receiver " + Object.prototype.toString.call(t));
              if (!0 !== t._es6Set)
                  throw new TypeError("Method Set.prototype.delete called on incompatible receiver " + Object.prototype.toString.call(t));
              for (var n = t._values, a = 0; a < n.length; a++) {
                  var i = n[a];
                  if (i !== o && SameValueZero(i, e))
                      return n[a] = o,
                      this._size = --this._size,
                      r || (this.size = this._size),
                      !0
              }
              return !1
          }),
          CreateMethodProperty(n.prototype, "entries", function u() {
              return t(this, "key+value")
          }),
          CreateMethodProperty(n.prototype, "forEach", function f(e) {
              var t = this;
              if ("object" != typeof t)
                  throw new TypeError("Method Set.prototype.forEach called on incompatible receiver " + Object.prototype.toString.call(t));
              if (!0 !== t._es6Set)
                  throw new TypeError("Method Set.prototype.forEach called on incompatible receiver " + Object.prototype.toString.call(t));
              if (!IsCallable(e))
                  throw new TypeError(Object.prototype.toString.call(e) + " is not a function.");
              if (arguments[1])
                  var r = arguments[1];
              for (var n = t._values, a = 0; a < n.length; a++) {
                  var i = n[a];
                  i !== o && e.call(r, i, i, t)
              }
              return undefined
          }),
          CreateMethodProperty(n.prototype, "has", function d(e) {
              var t = this;
              if ("object" != typeof t)
                  throw new TypeError("Method Set.prototype.forEach called on incompatible receiver " + Object.prototype.toString.call(t));
              if (!0 !== t._es6Set)
                  throw new TypeError("Method Set.prototype.forEach called on incompatible receiver " + Object.prototype.toString.call(t));
              for (var r = t._values, n = 0; n < r.length; n++) {
                  var a = r[n];
                  if (a !== o && SameValueZero(a, e))
                      return !0
              }
              return !1
          });
          var a = function h() {
              return t(this, "value")
          };
          CreateMethodProperty(n.prototype, "values", a),
          CreateMethodProperty(n.prototype, "keys", a),
          r && Object.defineProperty(n.prototype, "size", {
              configurable: !0,
              enumerable: !1,
              get: function() {
                  var e = this;
                  if ("object" != typeof e)
                      throw new TypeError("Method Set.prototype.size called on incompatible receiver " + Object.prototype.toString.call(e));
                  if (!0 !== e._es6Set)
                      throw new TypeError("Method Set.prototype.size called on incompatible receiver " + Object.prototype.toString.call(e));
                  for (var t = e._values, r = 0, n = 0; n < t.length; n++) {
                      t[n] !== o && (r += 1)
                  }
                  return r
              },
              set: undefined
          }),
          CreateMethodProperty(n.prototype, Symbol.iterator, a),
          "name"in n || Object.defineProperty(n, "name", {
              configurable: !0,
              enumerable: !1,
              writable: !1,
              value: "Set"
          });
          var i = {};
          Object.defineProperty(i, "isSetIterator", {
              configurable: !1,
              enumerable: !1,
              writable: !1,
              value: !0
          }),
          CreateMethodProperty(i, "next", function b() {
              var e = this;
              if ("object" != typeof e)
                  throw new TypeError("Method %SetIteratorPrototype%.next called on incompatible receiver " + Object.prototype.toString.call(e));
              if (!e.isSetIterator)
                  throw new TypeError("Method %SetIteratorPrototype%.next called on incompatible receiver " + Object.prototype.toString.call(e));
              var t = e["[[IteratedSet]]"]
                , r = e["[[SetNextIndex]]"]
                , n = e["[[SetIterationKind]]"];
              if (t === undefined)
                  return CreateIterResultObject(undefined, !0);
              if (!t._es6Set)
                  throw new Error(Object.prototype.toString.call(t) + " does not have [[SetData]] internal slot.");
              for (var a = t._values, i = a.length; r < i; ) {
                  var l = a[r];
                  if (r += 1,
                  e["[[SetNextIndex]]"] = r,
                  l !== o)
                      return "key+value" === n ? CreateIterResultObject([l, l], !1) : CreateIterResultObject(l, !1)
              }
              return e["[[IteratedSet]]"] = undefined,
              CreateIterResultObject(undefined, !0)
          }),
          CreateMethodProperty(i, Symbol.iterator, function s() {
              return this
          });
          try {
              CreateMethodProperty(e, "Set", n)
          } catch (l) {
              e.Set = n
          }
      }(self);
  }
  if (!("from"in Array && function() {
      try {
          return Array.from({
              length: -Infinity
          }),
          "a" === Array.from(new self.Set(["a"]))[0] && "a" === Array.from(new self.Map([["a", "one"]]))[0][0]
      } catch (r) {
          return !1
      }
  }())) {
      !function() {
          function r(r) {
              return "string" == typeof r || "object" == typeof r && "[object String]" === t.call(r)
          }
          var t = Object.prototype.toString
            , e = String.prototype.match;
          CreateMethodProperty(Array, "from", function o(t) {
              var o = this
                , a = arguments.length > 1 ? arguments[1] : undefined;
              if (a === undefined)
                  var n = !1;
              else {
                  if (!1 === IsCallable(a))
                      throw new TypeError(Object.prototype.toString.call(a) + " is not a function.");
                  var i = arguments.length > 2 ? arguments[2] : undefined;
                  if (i !== undefined)
                      var l = i;
                  else
                      l = undefined;
                  n = !0
              }
              var u = GetMethod(t, Symbol.iterator);
              if (u !== undefined) {
                  if (IsConstructor(o))
                      var f = Construct(o);
                  else
                      f = ArrayCreate(0);
                  for (var c = GetIterator(t, u), s = 0; ; ) {
                      if (s >= Math.pow(2, 53) - 1) {
                          var h = new TypeError("Iteration count can not be greater than or equal 9007199254740991.");
                          return IteratorClose(c, h)
                      }
                      var y = ToString(s)
                        , C = IteratorStep(c);
                      if (!1 === C)
                          return f.length = s,
                          f;
                      var g = IteratorValue(C);
                      if (n)
                          try {
                              var p = Call(a, l, [g, s])
                          } catch (b) {
                              return IteratorClose(c, b)
                          }
                      else
                          p = g;
                      try {
                          CreateDataPropertyOrThrow(f, y, p)
                      } catch (b) {
                          return IteratorClose(c, b)
                      }
                      s += 1
                  }
              }
              if (r(t))
                  var v = e.call(t, /[\uD800-\uDBFF][\uDC00-\uDFFF]?|[^\uD800-\uDFFF]|./g) || [];
              else
                  v = ToObject(t);
              var d = ToLength(Get(v, "length"));
              for (f = IsConstructor(o) ? Construct(o, [d]) : ArrayCreate(d),
              s = 0; s < d; ) {
                  y = ToString(s);
                  var I = Get(v, y);
                  p = !0 === n ? Call(a, l, [I, s]) : I,
                  CreateDataPropertyOrThrow(f, y, p),
                  s += 1
              }
              return f.length = d,
              f
          })
      }();
  }
  !function(e) {
      "use strict";
      function t(t) {
          return !!t && ("Symbol"in e && "iterator"in e.Symbol && "function" == typeof t[Symbol.iterator] || !!Array.isArray(t))
      }
      !function() {
          function n(e) {
              var t = ""
                , n = !0;
              return e.forEach(function(e) {
                  var r = encodeURIComponent(e.name)
                    , a = encodeURIComponent(e.value);
                  n || (t += "&"),
                  t += r + "=" + a,
                  n = !1
              }),
              t.replace(/%20/g, "+")
          }
          function r(e) {
              return e.replace(/((%[0-9A-Fa-f]{2})*)/g, function(e, t) {
                  return decodeURIComponent(t)
              })
          }
          function a(e, t) {
              var n = e.split("&");
              t && -1 === n[0].indexOf("=") && (n[0] = "=" + n[0]);
              var a = [];
              n.forEach(function(e) {
                  if (0 !== e.length) {
                      var t = e.indexOf("=");
                      if (-1 !== t)
                          var n = e.substring(0, t)
                            , r = e.substring(t + 1);
                      else
                          n = e,
                          r = "";
                      n = n.replace(/\+/g, " "),
                      r = r.replace(/\+/g, " "),
                      a.push({
                          name: n,
                          value: r
                      })
                  }
              });
              var i = [];
              return a.forEach(function(e) {
                  i.push({
                      name: r(e.name),
                      value: r(e.value)
                  })
              }),
              i
          }
          function i(e) {
              if (c)
                  return new s(e);
              var t = document.createElement("a");
              return t.href = e,
              t
          }
          function o(e) {
              var r = this;
              this._list = [],
              e === undefined || null === e || (e instanceof o ? this._list = a(String(e)) : "object" == typeof e && t(e) ? Array.from(e).forEach(function(e) {
                  if (!t(e))
                      throw TypeError();
                  var n = Array.from(e);
                  if (2 !== n.length)
                      throw TypeError();
                  r._list.push({
                      name: String(n[0]),
                      value: String(n[1])
                  })
              }) : "object" == typeof e && e ? Object.keys(e).forEach(function(t) {
                  r._list.push({
                      name: String(t),
                      value: String(e[t])
                  })
              }) : (e = String(e),
              "?" === e.substring(0, 1) && (e = e.substring(1)),
              this._list = a(e))),
              this._url_object = null,
              this._setList = function(e) {
                  i || (r._list = e)
              }
              ;
              var i = !1;
              this._update_steps = function() {
                  i || (i = !0,
                  r._url_object && ("about:" === r._url_object.protocol && -1 !== r._url_object.pathname.indexOf("?") && (r._url_object.pathname = r._url_object.pathname.split("?")[0]),
                  r._url_object.search = n(r._list),
                  i = !1))
              }
          }
          function u(e, t) {
              var n = 0;
              this.next = function() {
                  if (n >= e.length)
                      return {
                          done: !0,
                          value: undefined
                      };
                  var r = e[n++];
                  return {
                      done: !1,
                      value: "key" === t ? r.name : "value" === t ? r.value : [r.name, r.value]
                  }
              }
          }
          function l(t, n) {
              function r() {
                  var e = l.href.replace(/#$|\?$|\?(?=#)/g, "");
                  l.href !== e && (l.href = e)
              }
              function u() {
                  m._setList(l.search ? a(l.search.substring(1)) : []),
                  m._update_steps()
              }
              if (!(this instanceof e.URL))
                  throw new TypeError("Failed to construct 'URL': Please use the 'new' operator.");
              n && (t = function() {
                  if (c)
                      return new s(t,n).href;
                  var e;
                  try {
                      var r;
                      if ("[object OperaMini]" === Object.prototype.toString.call(window.operamini) ? (e = document.createElement("iframe"),
                      e.style.display = "none",
                      document.documentElement.appendChild(e),
                      r = e.contentWindow.document) : document.implementation && document.implementation.createHTMLDocument ? r = document.implementation.createHTMLDocument("") : document.implementation && document.implementation.createDocument ? (r = document.implementation.createDocument("http://www.w3.org/1999/xhtml", "html", null),
                      r.documentElement.appendChild(r.createElement("head")),
                      r.documentElement.appendChild(r.createElement("body"))) : window.ActiveXObject && (r = new window.ActiveXObject("htmlfile"),
                      r.write("<head></head><body></body>"),
                      r.close()),
                      !r)
                          throw Error("base not supported");
                      var a = r.createElement("base");
                      a.href = n,
                      r.getElementsByTagName("head")[0].appendChild(a);
                      var i = r.createElement("a");
                      return i.href = t,
                      i.href
                  } finally {
                      e && e.parentNode.removeChild(e)
                  }
              }());
              var l = i(t || "")
                , f = function() {
                  if (!("defineProperties"in Object))
                      return !1;
                  try {
                      var e = {};
                      return Object.defineProperties(e, {
                          prop: {
                              get: function() {
                                  return !0
                              }
                          }
                      }),
                      e.prop
                  } catch (t) {
                      return !1
                  }
              }()
                , h = f ? this : document.createElement("a")
                , m = new o(l.search ? l.search.substring(1) : null);
              return m._url_object = h,
              Object.defineProperties(h, {
                  href: {
                      get: function() {
                          return l.href
                      },
                      set: function(e) {
                          l.href = e,
                          r(),
                          u()
                      },
                      enumerable: !0,
                      configurable: !0
                  },
                  origin: {
                      get: function() {
                          return "data:" === this.protocol.toLowerCase() ? null : "origin"in l ? l.origin : this.protocol + "//" + this.host
                      },
                      enumerable: !0,
                      configurable: !0
                  },
                  protocol: {
                      get: function() {
                          return l.protocol
                      },
                      set: function(e) {
                          l.protocol = e
                      },
                      enumerable: !0,
                      configurable: !0
                  },
                  username: {
                      get: function() {
                          return l.username
                      },
                      set: function(e) {
                          l.username = e
                      },
                      enumerable: !0,
                      configurable: !0
                  },
                  password: {
                      get: function() {
                          return l.password
                      },
                      set: function(e) {
                          l.password = e
                      },
                      enumerable: !0,
                      configurable: !0
                  },
                  host: {
                      get: function() {
                          var e = {
                              "http:": /:80$/,
                              "https:": /:443$/,
                              "ftp:": /:21$/
                          }[l.protocol];
                          return e ? l.host.replace(e, "") : l.host
                      },
                      set: function(e) {
                          l.host = e
                      },
                      enumerable: !0,
                      configurable: !0
                  },
                  hostname: {
                      get: function() {
                          return l.hostname
                      },
                      set: function(e) {
                          l.hostname = e
                      },
                      enumerable: !0,
                      configurable: !0
                  },
                  port: {
                      get: function() {
                          return l.port
                      },
                      set: function(e) {
                          l.port = e
                      },
                      enumerable: !0,
                      configurable: !0
                  },
                  pathname: {
                      get: function() {
                          return "/" !== l.pathname.charAt(0) ? "/" + l.pathname : l.pathname
                      },
                      set: function(e) {
                          l.pathname = e
                      },
                      enumerable: !0,
                      configurable: !0
                  },
                  search: {
                      get: function() {
                          return l.search
                      },
                      set: function(e) {
                          l.search !== e && (l.search = e,
                          r(),
                          u())
                      },
                      enumerable: !0,
                      configurable: !0
                  },
                  searchParams: {
                      get: function() {
                          return m
                      },
                      enumerable: !0,
                      configurable: !0
                  },
                  hash: {
                      get: function() {
                          return l.hash
                      },
                      set: function(e) {
                          l.hash = e,
                          r()
                      },
                      enumerable: !0,
                      configurable: !0
                  },
                  toString: {
                      value: function() {
                          return l.toString()
                      },
                      enumerable: !1,
                      configurable: !0
                  },
                  valueOf: {
                      value: function() {
                          return l.valueOf()
                      },
                      enumerable: !1,
                      configurable: !0
                  }
              }),
              h
          }
          var c, s = e.URL;
          try {
              if (s) {
                  if ("searchParams"in (c = new e.URL("http://example.com"))) {
                      var f = new l("http://example.com");
                      if (f.search = "a=1&b=2",
                      "http://example.com/?a=1&b=2" === f.href && (f.search = "",
                      "http://example.com/" === f.href))
                          return
                  }
                  "href"in c || (c = undefined),
                  c = undefined
              }
          } catch (m) {}
          if (Object.defineProperties(o.prototype, {
              append: {
                  value: function(e, t) {
                      this._list.push({
                          name: e,
                          value: t
                      }),
                      this._update_steps()
                  },
                  writable: !0,
                  enumerable: !0,
                  configurable: !0
              },
              "delete": {
                  value: function(e) {
                      for (var t = 0; t < this._list.length; )
                          this._list[t].name === e ? this._list.splice(t, 1) : ++t;
                      this._update_steps()
                  },
                  writable: !0,
                  enumerable: !0,
                  configurable: !0
              },
              get: {
                  value: function(e) {
                      for (var t = 0; t < this._list.length; ++t)
                          if (this._list[t].name === e)
                              return this._list[t].value;
                      return null
                  },
                  writable: !0,
                  enumerable: !0,
                  configurable: !0
              },
              getAll: {
                  value: function(e) {
                      for (var t = [], n = 0; n < this._list.length; ++n)
                          this._list[n].name === e && t.push(this._list[n].value);
                      return t
                  },
                  writable: !0,
                  enumerable: !0,
                  configurable: !0
              },
              has: {
                  value: function(e) {
                      for (var t = 0; t < this._list.length; ++t)
                          if (this._list[t].name === e)
                              return !0;
                      return !1
                  },
                  writable: !0,
                  enumerable: !0,
                  configurable: !0
              },
              set: {
                  value: function(e, t) {
                      for (var n = !1, r = 0; r < this._list.length; )
                          this._list[r].name === e ? n ? this._list.splice(r, 1) : (this._list[r].value = t,
                          n = !0,
                          ++r) : ++r;
                      n || this._list.push({
                          name: e,
                          value: t
                      }),
                      this._update_steps()
                  },
                  writable: !0,
                  enumerable: !0,
                  configurable: !0
              },
              entries: {
                  value: function() {
                      return new u(this._list,"key+value")
                  },
                  writable: !0,
                  enumerable: !0,
                  configurable: !0
              },
              keys: {
                  value: function() {
                      return new u(this._list,"key")
                  },
                  writable: !0,
                  enumerable: !0,
                  configurable: !0
              },
              values: {
                  value: function() {
                      return new u(this._list,"value")
                  },
                  writable: !0,
                  enumerable: !0,
                  configurable: !0
              },
              forEach: {
                  value: function(e) {
                      var t = arguments.length > 1 ? arguments[1] : undefined;
                      this._list.forEach(function(n) {
                          e.call(t, n.value, n.name)
                      })
                  },
                  writable: !0,
                  enumerable: !0,
                  configurable: !0
              },
              toString: {
                  value: function() {
                      return n(this._list)
                  },
                  writable: !0,
                  enumerable: !1,
                  configurable: !0
              },
              sort: {
                  value: function p() {
                      for (var e = this.entries(), t = e.next(), n = [], r = {}; !t.done; ) {
                          var a = t.value
                            , i = a[0];
                          n.push(i),
                          Object.prototype.hasOwnProperty.call(r, i) || (r[i] = []),
                          r[i].push(a[1]),
                          t = e.next()
                      }
                      n.sort();
                      for (var o = 0; o < n.length; o++)
                          this["delete"](n[o]);
                      for (var u = 0; u < n.length; u++)
                          i = n[u],
                          this.append(i, r[i].shift())
                  }
              }
          }),
          "Symbol"in e && "iterator"in e.Symbol && (Object.defineProperty(o.prototype, e.Symbol.iterator, {
              value: o.prototype.entries,
              writable: !0,
              enumerable: !0,
              configurable: !0
          }),
          Object.defineProperty(u.prototype, e.Symbol.iterator, {
              value: function() {
                  return this
              },
              writable: !0,
              enumerable: !0,
              configurable: !0
          })),
          s)
              for (var h in s)
                  Object.prototype.hasOwnProperty.call(s, h) && "function" == typeof s[h] && (l[h] = s[h]);
          e.URL = l,
          e.URLSearchParams = o
      }(),
      function() {
          if ("1" !== new e.URLSearchParams([["a", 1]]).get("a") || "1" !== new e.URLSearchParams({
              a: 1
          }).get("a")) {
              var n = e.URLSearchParams;
              e.URLSearchParams = function(e) {
                  if (e && "object" == typeof e && t(e)) {
                      var r = new n;
                      return Array.from(e).forEach(function(e) {
                          if (!t(e))
                              throw TypeError();
                          var n = Array.from(e);
                          if (2 !== n.length)
                              throw TypeError();
                          r.append(n[0], n[1])
                      }),
                      r
                  }
                  return e && "object" == typeof e ? (r = new n,
                  Object.keys(e).forEach(function(t) {
                      r.set(t, e[t])
                  }),
                  r) : new n(e)
              }
          }
      }()
  }(self);
  if (!("URL"in self && "toJSON"in self.URL.prototype)) {
      !function(t) {
          t.URL.prototype.toJSON = function n() {
              return this.href
          }
      }(self);
  }
}
)('object' === typeof window && window || 'object' === typeof self && self || 'object' === typeof global && global || {});
}
export default addURLToGlobal

